module.exports = __webpack_public_path__ + "static/img/stateLaborMin.c978496.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stateLaborMin.jpg
// module id = /do1
// module chunks = 0